import { ROLES } from "../../auth/constants";

const config = {
  SITE: 'quality_nonprod',
  LABEL: 'Quality',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,ec7f5839-4ac7-44e8-ba35-5d6c46a20027',
  PAGES_LIST_ID: 'cf197018-6291-4a86-928c-4facc46dd357',
  DOCUMENTS_LIST_ID: '56eb9576-019e-4296-868e-c21dbbfa5ccd',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuDlYf-zHSuhEujVdbEaiACdk8HIjYxhpRr-MnH1rAi-V',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuDlYf-zHSuhEujVdbEaiACd2letWngGWQoaOwh27-lzN',
  NEWS_TEMPLATE_ID: '84ea449a-2e7b-4f83-9670-cdc63933ef14',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  MANAGER_ROLES: [ROLES.QSE_MGR],
  VIVA_COMMUNITY_ID: undefined
}

export default config